import React from 'react'
import styles from './index.module.css'

export type HoverContainerProps = { className?: string; children: React.ReactNode; as?: any; disabled?: boolean }

export const HoverContainer = ({ children, as, className = '', disabled }: HoverContainerProps) => {
  const As = as ?? 'div'
  let hoverContainerClassName = styles.hoverContainer

  //if disabled, don't show the context menu
  if (disabled) hoverContainerClassName = ''

  return <As className={`${hoverContainerClassName} ${className}`}>{children}</As>
}

export const HoverMenuContainer = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles.hoverMenu}>{children}</div>
}
